import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import AutoScroll from 'embla-carousel-auto-scroll';
import './Carousel.scss';

const Carousel = ({
  slides,
  options,
  autoScroll,
  containerClassName,
  viewportClassName,
  emblaClassName,
  autoScrollOptions,
  ...props
}) => {
  const [emblaRef] = useEmblaCarousel(options, autoScroll && [AutoScroll(autoScrollOptions)]);

  return (
    <section className={`embla ${emblaClassName}`} >
      <div className={`embla__viewport ${viewportClassName}`} ref={emblaRef} >
        <div className={`embla__container ${containerClassName}`} ref={props.reference} >
          {slides}
        </div>
      </div>
    </section>
  )
}

export default Carousel;
